import React from 'react'
import { Skeleton } from 'antd'
import {
  CardText,
  CardValue,
  SingleCard,
} from 'components/InfoCardsUpdateClick/style'
import { IconTextContainer, TextWrapper } from './style'

const InfoCardsUpdateClick = ({
  background,
  padding = '15px 25px',
  width = 'auto',
  icon,
  text,
  value,
  onClick,
  isSelected = false,
  borderColor,
  valueColor,
  loading,
  IconText,
}) => {
  return (
    <SingleCard
      data-test={background}
      background={background}
      padding={padding}
      width={width}
      column
      flexStart
      onClick={onClick}
      borderColor={borderColor}
    >
      <IconTextContainer>
        {icon}
        {IconText && <TextWrapper>{IconText}</TextWrapper>}
      </IconTextContainer>
      <CardText isSelected={isSelected}>{text}</CardText>
      {loading ? (
        <Skeleton.Avatar active={true} size={'default'} shape={'square'} />
      ) : (
        <CardValue valueColor={valueColor}>{value}</CardValue>
      )}
    </SingleCard>
  )
}

export default InfoCardsUpdateClick
